import { COLOR_PALETTE } from 'constants/ui';

export const cardStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '14px',
  maxWidth: '440px',
  padding: '12px 14px',
  border: ({ palette }) => `1px solid ${palette.border.input}`,
  borderRadius: ({ shape }) => shape.radius.l,
  backgroundColor: ({ palette }) => palette.background.paper,
  boxShadow: ({ palette }) => palette.shadow.s,
};

export const detailsStyles = {
  minWidth: 0,
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
};

export const nameStyles = {
  color: ({ palette }) => palette.text.primary,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const viewLinkStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  alignSelf: 'flex-start',
  color: COLOR_PALETTE.BLUE[7],
  lineHeight: 1,
  textDecoration: 'none',
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline',
  },
};

export const removeButtonStyles = {
  width: '30px',
  height: '30px',
  padding: 0,
  color: ({ palette }) => palette.text.placeholder,
  '&:hover': {
    backgroundColor: COLOR_PALETTE.RED[1],
    color: COLOR_PALETTE.RED[6],
  },
};
